/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [ { if: { viewport: [ 'lg', 'xl' ] }, tokens: { space: 3 } } ],
  tokens: {
    alignItems: 'flex-start',
    direction: 'column',
    fieldSpace: 2,
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'flex-start',
    space: 3
  }
}
export default theme
